import React from "react";
import { ListItemAvatar, ListItemText, Avatar, Box, Typography } from "@mui/material";
import ENV from "../../config/env";
import { TIPO_CONFIG, TIPO_DEFAULT, formatDateTime, timeAgo, getNotificationFields } from "./notificationHelpers";

// Solo el contenido (avatar + textos) — el que lo usa decide el contenedor
// clickeable (MenuItem en el dropdown, ListItemButton en la página completa).
export default function NotificationRow({ n, avatarSize = 28 }) {
  const { primary, usuario, tipo, fecha } = getNotificationFields(n);
  const { icon: TipoIcon, bg, fg } = TIPO_CONFIG[tipo] || TIPO_DEFAULT;

  return (
    <>
      <ListItemAvatar sx={{ minWidth: avatarSize + 10 }}>
        <Avatar
          src={n.foto_usuario ? `${ENV.API_BASE_URL}${n.foto_usuario}` : undefined}
          sx={{ bgcolor: bg, color: fg, width: avatarSize, height: avatarSize }}
        >
          <TipoIcon sx={{ fontSize: 15 }} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        sx={{ minWidth: 0, my: 0 }}
        primary={primary}
        primaryTypographyProps={{
          sx: {
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            whiteSpace: "normal",
            fontSize: 13.5,
            lineHeight: 1.3,
          },
        }}
        secondary={
          <>
            <Typography component="span" variant="caption" color="text.secondary" noWrap sx={{ display: "block", fontSize: 12 }}>
              {usuario && (
                <Box component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
                  {usuario}
                </Box>
              )}
              {usuario && tipo ? " • " : ""}
              {tipo}
            </Typography>
            {fecha && (
              <Typography
                component="span"
                variant="caption"
                color="text.disabled"
                title={formatDateTime(fecha)}
                sx={{ display: "block", mt: 0.1, fontSize: 11 }}
              >
                {timeAgo(fecha)}
              </Typography>
            )}
          </>
        }
        secondaryTypographyProps={{ component: "div" }}
      />
    </>
  );
}
